import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';
import * as S from '../styles';
import SquadContainer from '../../SquadContent';

export default function MatchTeamMobile({
  isLocal,
  squad,
  trainer,
  className,
  formation,
}) {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState('0');
  return (
    <S.LocalColumn isLocal={isLocal} image={null} className={className}>
      <S.TeamSquad isLocal={isLocal}>
        <S.SquadColumn width="100%">
          <S.TeamSubheaderColumn isLocal={isLocal}>
            <h3>{t('alignment')}</h3>
            <p>
              <span>{t('trainer')}</span>
              {trainer ? trainer.nickname : '-'}
            </p>
          </S.TeamSubheaderColumn>
        </S.SquadColumn>
        <S.SquadColumn width="100%" isCourt>
          <S.Court>
            {formation.map(row => {
              return (
                <S.Row key={v4()}>
                  {row.map(cell => {
                    if (cell !== null) {
                      return (
                        <S.Player
                          key={v4()}
                          image={cell.photo}
                          hovered={hovered === cell.shirtNumber}
                          onMouseOver={() => setHovered(cell.shirtNumber)}
                          onMouseOut={() => setHovered('0')}
                        >
                          <S.ShirtNumber isLocal={isLocal}>
                            {cell.shirtNumber}
                          </S.ShirtNumber>
                        </S.Player>
                      );
                    }
                    return null;
                  })}
                </S.Row>
              );
            })}
          </S.Court>
        </S.SquadColumn>
        <S.SquadColumn width="100%">
          <SquadContainer
            squad={squad}
            isLocal={isLocal}
            showAll={false}
            hoveredPlayer={hovered}
            onHover={setHovered}
          />
        </S.SquadColumn>
      </S.TeamSquad>
    </S.LocalColumn>
  );
}

MatchTeamMobile.propTypes = {
  squad: PropTypes.array,
  trainer: PropTypes.object,
  isLocal: PropTypes.bool,
  className: PropTypes.string,
  formation: PropTypes.array,
};

MatchTeamMobile.defaultProps = {
  squad: [],
  trainer: '',
  isLocal: false,
  className: null,
  formation: [],
};
